export const HeaderOptions = [
  { heading: 'Audio', path: '/listeners-reviews/audio' },
  { heading: 'Video', path: '/listeners-reviews/video' },
  { heading: 'Avatars', path: '/listeners-reviews/profiles' },
  { heading: 'Display Name', path: '/listeners-reviews/display-name' },
  { heading: 'About Me', path: '/listeners-reviews/about-me' },
  { heading: 'Background Tags', path: '/listeners-reviews/background-tags' },
];
